import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { PageError, Preloader } from '../../../components/ui';
import { useSocialConnections } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { tokenExpiryErrorCheck } from '../../../utils';
import { SocialSettingsPage } from './SocialSettingsPage';

type RouteParams = {
  socialName: string;
  projectId: string;
};

const SocialSettings = ({ match, history }: RouteComponentProps): JSX.Element => {
  const intl = useIntl();
  const { projectId, socialName } = match.params as RouteParams;
  const { currentSocialsFetching, error } = useSocialConnections(projectId);
  const { socialConnectionPath } = usePaths();

  const backToSocialList = () => {
    history.push(socialConnectionPath(projectId));
  };

  const loginPage = useCallback(() => {
    history.push('/');
  }, []);

  if (currentSocialsFetching) {
    return <Preloader />;
  }

  if (error) {
    const expiredToken = tokenExpiryErrorCheck(error.code);
    return (
      <PageError
        title={intl.formatMessage({ id: 'app.error.page.label' })}
        error={error}
        buttonText={intl.formatMessage({ id: `${expiredToken ? 'button.login' : 'button.back'}` })}
        onClick={expiredToken ? loginPage : backToSocialList}
      />
    );
  }

  return <SocialSettingsPage projectId={projectId} socialName={socialName} />;
};

export default withRouter(SocialSettings);
